export default __webpack_public_path__ + "static/media/adventures.0fda8049.png";